import React, { useEffect, useState, useRef } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import { Card, Button, Collapse, Row, Col, Badge, Spinner } from "react-bootstrap";
import { ArrowDown, CaretDown, CaretUp, Island } from "@phosphor-icons/react";

import "react-bootstrap-typeahead/css/Typeahead.css";
import { API_URL } from "..";
// import {
//   GoogleMap,
//   Marker,
//   InfoWindow,
//   useJsApiLoader,
//   Autocomplete,
//   LoadScript
// } from "@react-google-maps/api";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { Typeahead } from "react-bootstrap-typeahead";
import { useMapbox } from "../GoogleMapsContext";
import swal from "sweetalert";
import axios from "axios";
// import { useGoogleMaps } from "../GoogleMapsContext";
mapboxgl.accessToken = "pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ";

const containerStyle = {
  width: "100%",
  height: "300px",
};
const getStatusColor = (status) => {
  switch (status) {
    case "Waiting":
      return "gray";
    case "Dispatched":
      return "blue";
    case "Enroute":
      return "orange";
    case "On Scene":
      return "green";
    case "active":
      return "green";
    case "Being Towed":
      return "red";
    case "Destination Arrival":
      return "purple";
    case "Completed":
      return "black";
    default:
      return "gray";
  }
};
function getYearsArray() {
  const currentYear = new Date().getFullYear(); // 2025 as of March 04, 2025
  const startYear = 1927;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(`${year}`);
  }

  return years;
}
function getVehicleModelsByMake(vehicleMake) {
  const makeModelMapping = {
    Acura: ["ILX", "MDX", "NSX", "RDX", "TLX"],
    "Alfa Romeo": ["Giulia", "Stelvio", "Tonale"],
    Audi: ["A3", "A4", "A5", "A6", "Q3", "Q5", "Q7", "e-tron"],
    BMW: ["3 Series", "5 Series", "X3", "X5", "i4", "iX"],
    Chevrolet: ["Camaro", "Corvette", "Silverado", "Equinox", "Tahoe"],
    Chrysler: ["Pacifica", "300"],
    Dodge: ["Challenger", "Charger", "Durango"],
    Ford: ["Mustang", "F-150", "Bronco", "Explorer", "Mach-E"],
    GMC: ["Sierra", "Yukon", "Terrain", "Hummer EV"],
    Honda: ["Civic", "Accord", "CR-V", "Pilot"],
    Hyundai: ["Elantra", "Sonata", "Tucson", "Santa Fe", "Ioniq 5"],
    Jeep: ["Wrangler", "Grand Cherokee", "Cherokee", "Gladiator"],
    Kia: ["Forte", "Optima", "Sportage", "Telluride", "EV6"],
    Lexus: ["RX", "NX", "ES", "IS"],
    "Mercedes-Benz": ["C-Class", "E-Class", "GLC", "GLE", "EQE"],
    Nissan: ["Altima", "Sentra", "Rogue", "Pathfinder", "Leaf"],
    Porsche: ["911", "Cayenne", "Macan", "Taycan"],
    Ram: ["1500", "2500", "3500"],
    Subaru: ["Outback", "Forester", "Crosstrek"],
    Tesla: ["Model 3", "Model S", "Model X", "Model Y", "Cybertruck"],
    Toyota: ["Camry", "Corolla", "RAV4", "Highlander", "Tacoma"],
    Volkswagen: ["Jetta", "Passat", "Tiguan", "Atlas", "ID.4"],
  };

  // Return the models for the given make, or an empty array if make is invalid
  return makeModelMapping[vehicleMake] || [];
}
function getVehicleMakes() {
  return [
    "Acura",
    "Alfa Romeo",
    "AM General",
    "Aston Martin",
    "Audi",
    "Bentley",
    "BMW",
    "Buick",
    "Cadillac",
    "Chevrolet",
    "Chrysler",
    "Dodge",
    "Ferrari",
    "Fiat",
    "Ford",
    "Genesis",
    "GMC",
    "Honda",
    "Hummer",
    "Hyundai",
    "Infiniti",
    "Jaguar",
    "Jeep",
    "Kia",
    "Lamborghini",
    "Land Rover",
    "Lexus",
    "Lincoln",
    "Lotus",
    "Lucid",
    "Maserati",
    "Mazda",
    "McLaren",
    "Mercedes-Benz",
    "Mini",
    "Mitsubishi",
    "Nissan",
    "Porsche",
    "Ram",
    "Rivian",
    "Rolls-Royce",
    "Subaru",
    "Tesla",
    "Toyota",
    "Volkswagen",
    "Volvo",
  ];
}
const options = [
  { value: "Light Duty Towing", label: "Light Duty Towing" },
  { value: "Medium Duty Towing", label: "Medium Duty Towing" },
  { value: "Heavy Duty Towing", label: "Heavy Duty Towing" },
  { value: "Flatbed Towing", label: "Flatbed Towing" },
  { value: "Motorcycle Towing", label: "Motorcycle Towing" },
  { value: "Long-Distance Towing", label: "Long-Distance Towing" },
  { value: "Emergency Towing", label: "Emergency Towing" },
  { value: "Accident Recovery", label: "Accident Recovery" },
  { value: "Winch-Out Services", label: "Winch-Out Services" },
  { value: "Roadside Assistance", label: "Roadside Assistance" },
  { value: "Fuel Delivery", label: "Fuel Delivery" },
  { value: "Lockout Services", label: "Lockout Services" },
  { value: "Tire Change Services", label: "Tire Change Services" },
  { value: "Jump Start Services", label: "Jump Start Services" },
  { value: "Impound Towing", label: "Impound Towing" },
  { value: "Speciality Vehicle Towing", label: "Speciality Vehicle Towing" },
  { value: "Classic Car Towing", label: "Classic Car Towing" },
  { value: "Fleet Services", label: "Fleet Services" },
  { value: "Commercial Towing", label: "Commercial Towing" },
  {
    value: "Recreational Vehicle Towing",
    label: "Recreational Vehicle Towing",
  },
];
function getCarColorsArray() {
  return [
    // Most Popular Colors (based on 2023 iSeeCars data and general trends)
    "White",
    "Black",
    "Gray",
    "Silver",
    "Blue",
    "Red",
    
    // Additional Common Colors
    "Green",
    "Brown",
    "Orange",
    "Beige",
    "Purple",
    "Gold",
    "Yellow",
    
    // Shades and Variations
    "Pearl White",
    "Matte Black",
    "Metallic Gray",
    "Silver Metallic",
    "Navy Blue",
    "Bright Red",
    "Forest Green",
    "Chocolate Brown",
    "Burnt Orange",
    "Tan",
    "Deep Purple",
    "Champagne Gold",
    "Lemon Yellow",
    
    // Specialty and Notable Colors (from manufacturers)
    "Rosso Corsa", // Ferrari iconic red
    "Nardo Grey", // Audi signature grey
    "Ultra Red", // Tesla
    "Blue Flame", // Toyota GR Corolla
    "Podium Green", // Aston Martin DBX707
    "Tiger Eye Pearl", // Acura TLX Type S
    "Kyalami Green", // Audi RS3
    "Twilight Purple", // Rolls-Royce Spectre
    "Jetstream II", // Bentley Continental GT
    "Diffused Sky Pearl", // Honda Pilot TrailSport
    "Cacti Green", // Chevrolet Corvette E-Ray
    "Bronze Age", // Toyota Crown
    "Artisan Red", // Mazda CX-90
    "Python Green", // Porsche 911
    "Earl Gray", // Jeep Wrangler
    "Frozen Berry Metallic", // Porsche Taycan
    "Sub-lime", // Dodge High Impact Line
    "Hugger Orange", // Chevrolet Camaro classic
    "Liquid Yellow", // Renault
    
    // Miscellaneous
    "Teal",
    "Cyan",
    "Magenta",
    "Indigo",
    "Maroon",
    "Burgundy",
    "Plum",
    "Fuchsia",
    "Aqua",
    "Lilac",
    "Sand",
    "Topaz",
    "Ash",
    "Charcoal",
    "Coral",
    "Amber",
    "Onyx",
  ];
}

// Usage

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
function formatDateToDDMMYYYY(dateString) {
  // Split the input string by '-'
  const [year, month, day] = dateString.split("-");
  
  // Ensure two digits for day and month by padding with zero if needed
  const formattedDay = day.padStart(2, "0");
  const formattedMonth = month.padStart(2, "0");
  
  // Return in DD/MM/YYYY format
  return `${formattedDay}/${formattedMonth}/${year}`;
}
const AddJobs = () => {
 const location = useLocation();
  const assignedTo = location.state || {};
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);
  // const { isLoaded } = useGoogleMaps();
  const incidentAutocompleteRef = useRef(null); // Ref for incident location
  const dropoffAutocompleteRef = useRef(null); 
  const { mapboxgl } = useMapbox(); // Get mapboxgl from context

  const [showAlertMessage, setshowAlertMessage] = useState({
    status: false,
    message: "",
    desc: "",
  });
  const [loading, setLoading] = useState(false);
  const [statusForLiveTracking, setStatusForLiveTracking] = useState(false);
  const [phone, setPhone] = useState("");
  const [jobType, setJobType] = useState("");
  const [callType, setCallType] = useState("New Call");
  const [priority, setPriority] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedOptionService, setSelectedOptionService] = useState([]);
  const [selectDriver, setSelectDriver] = useState([]);
  const [selectDriverSelect, setSelectDriverSelect] = useState(assignedTo);
  const [affiliatesData, setAffilatesData] = useState([]);
  const [filterAffilatesData, setFilterAffilatesData] = useState([]);
  const [services, setServices] = useState([]);
  const [extraCosts, setExtraCosts] = useState([]);
  const [tax, setTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [DriverData, setDriverData] = useState(null);
  const [jobsData, setJobData] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [singleCheckedArray, setSingleCheckedArray] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [listType, setListType] = useState("show_all");
  const [selected, setSelected] = useState([]); // Use array for selected items
  const vehicleOptions = ["Light", "Medium", "Tractor", "Equipment", "Container",  "Material" , "Other"];
  const [selectedYear, setSelectedYear] = useState([]); // Use array for selected items
  const VehicleYear = getYearsArray();
  const [selectedMake, setSelectedMake] = useState([]); // Use array for selected items
  const vehicleMake = getVehicleMakes();
  const [selectedModel, setSelectedModel] = useState([]); // Use array for selected items
  const [vehicleModelArray, setVehicleModelArray] = useState([])
  const carColors = getCarColorsArray();
  
  const [selectedPlace, setSelectedPlace] = useState(null); // Incident location
  const [selectedPlaceDropoff, setSelectedPlaceDropoff] = useState(null); // Dropoff location
  const [eta, setEta] = useState(null);
  const [selectedCarColor, setSelectedModelCarColor] = useState([]); // Use array for selected items
  const [invoiceNumber, setInvoiceNumber] = useState("INV_");
  const [completedDates, setCompletedDates] = useState({
    receivedDate: "",
    dispatchedDate: "",
    enRouteDate: "",
    onSceneDate: "",
    towingDate: "",
    destinationDate: "",
    completedDate: "",
  });
  const [scheduleDate, setScheduleDate] = useState("");
  const incidentInputRef = useRef(null);
  const dropoffInputRef = useRef(null);
  const [isMounted, setIsMounted] = useState(false);
  const incidentGeocoderRef = useRef(null);
  const dropoffGeocoderRef = useRef(null);
  const [tripCounter,setTripCounter] = useState({})
  
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
      // Cleanup geocoders when unmounting
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
        incidentGeocoderRef.current = null;
      }
      if (dropoffGeocoderRef.current) {
        dropoffGeocoderRef.current.onRemove();
        dropoffGeocoderRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (!isMounted || !mapboxgl.accessToken) return;

    // Clear existing containers
    const clearContainer = (id) => {
      const container = document.getElementById(id);
      if (container) container.innerHTML = '';
      return container;
    };

    const incidentContainer = clearContainer('incident-location-container');
    const dropoffContainer = clearContainer('dropoff-location-container');

    if (!incidentContainer || !dropoffContainer) return;

    // Initialize geocoders with fresh instances
    incidentGeocoderRef.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: 'Enter incident location',
      marker: false,
      
    });

    dropoffGeocoderRef.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: 'Enter dropoff location',
      marker: false
    });

    // Add to DOM
    incidentGeocoderRef.current.addTo(incidentContainer);
    dropoffGeocoderRef.current.addTo(dropoffContainer);

    // Event handlers
    incidentGeocoderRef.current.on('result', (e) => {
      const { place_name, center } = e.result;
      let pick = {
        address: place_name,
        lat: center[1],
        lng: center[0],
        name: place_name.split(',')[0]
      }
      setSelectedPlace(pick);
      localStorage.setItem('thisScreen', JSON.stringify(pick))
      if(currentUser.role === 'admin' || currentUser.role === 'user'){
        setSelectedPlace(pick);
        getLatLongFromAddress(center[1], center[0])
      }
    });

    dropoffGeocoderRef.current.on('result', (e) => {
      const { place_name, center } = e.result;
      const drop = {
        address: place_name,
        lat: center[1],
        lng: center[0],
        name: place_name.split(',')[0]
      }
      setSelectedPlaceDropoff(drop);
     const value =  JSON.parse(localStorage.getItem('thisScreen'))
      calculateETA(value, drop)
    });
    return () => {
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
      }
      if (dropoffGeocoderRef.current) {
        dropoffGeocoderRef.current.onRemove();
      }
    };
  }, [isMounted]);

  // Set mapbox loaded flag when component mounts
  
  const getLatLongFromAddress = async (lat, lng) => {
    try {
      let headersList = {
        Accept: "*/*",
        "Content-Type": "application/json",
      };

      let bodyContent = JSON.stringify({
        lat: lat,
        lng: lng,
      });

      let response = await fetch(API_URL + "/api/affiliates/nearby", {
        method: "POST",
        body: bodyContent,
        headers: headersList,
      });

      let newAffiliates = await response.json();

      if (response.status === 200 && newAffiliates.length !== 0) {
        setAffilatesData(newAffiliates);
        setFilterAffilatesData(newAffiliates);
        setListType("show_all");
      }else{
        setAffilatesData([]);
        setFilterAffilatesData([]);
        setListType("show_all");

      }
    } catch (error) {
      console.log(error.message)
    }
  };

  const fetchTripsData = async () => {
    const local = JSON.parse(localStorage.getItem('user'))
    try {
      const response = await axios.get(
        API_URL+`/api/reports/trip-counter/${local.id}`
      );
      setTripCounter(response.data)
    } catch (err) {
      console.error('Error fetching trips data:', err);
      
    }
  };
  const handleChange = (selected) => {
    setSelectedOptions(selected);
    // onChangeCompany(selected.value);
  };
  

  // const handleChangeDriver = async (selected) => {
  //   setSelectDriverSelect(selected || []);
  // };
 
  const fetchJobs = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };
    let response;
    if (user.role === "owner") {
      response = await fetch(
        `${API_URL}/api/affiliates/fetch-affiliate/${user.id}`,
        {
          method: "GET",
          headers: headersList,
        }
      );
      // onChangeCompany(user.id);
      let data = await response.json();
      if(data){
        setJobData([{ value: data.id, label: data.business_name }]);

      }
    } else {
      response = await fetch(API_URL + "/api/affiliates/fetch-affiliates", {
        method: "GET",
        headers: headersList,
      });
      let data = await response.json();

      const formattedData = data.map((e) => ({
        value: e.id,
        label: e.business_name,
      }));
      setJobData(formattedData);
    }
  };
  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");

    // Format the number as (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    const formatted = [
      match[1] && `(${match[1]}`,
      match[2] && `) ${match[2]}`,
      match[3] && `-${match[3]}`,
    ]
      .filter(Boolean)
      .join("");

    return formatted;
  };
  const handleInputChange = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };
  React.useEffect(() => {
    fetchJobs();
    
    fetchTripsData();
  }, [1]);
  const showPopUp = () => {
    const remainingTrips =
      parseFloat(tripCounter?.total_trips) - parseFloat(tripCounter?.used_trips);
  
    const tripColor = remainingTrips === 0 ? "red" : "black";
    const tripMessage =
      remainingTrips === 0
        ? "You have consumed all the free trips. Recharge your account."
        : `You have ${remainingTrips} free trips that you can track.`;
  
    // Create a custom HTML element
    const customContent = document.createElement("div");
  
    customContent.innerHTML = `
      <p style="font-size: 14px; font-weight: 500; color: ${tripColor}; padding-bottom: 10px;">
        ${tripMessage}
      </p>
      <p style="font-size: 14px; font-weight: 500; padding-bottom: 10px;">
        If you need to track more, head over to the Subscription section and upgrade to Premium for unlimited tracking! 🚀
      </p>
    `;
  
    swal({
      title: "Disclaimer",
      content: customContent,
      buttons: {
        cancel: {
          text: "Not Now",
          visible: true,
          className: "",
          closeModal: true,
        },
        confirm: {
          text: "Enable",
          closeModal: true,
          className: remainingTrips === 0 ? "disabled-btn" : "",
        },
      },
    }).then((willEnable) => {
      if (willEnable === true && remainingTrips > 0) {
        setStatusForLiveTracking(true);
      } else {
        setStatusForLiveTracking(false);
      }
    });
  };
  const onFormSubmit = async (event) => {
    event.preventDefault();

    const formattedData = selectedOptionService.map((e) => e.value);
    if (event.target.elements.address.value == "") {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Incident Address is required",
      });
      return false;
    }else if (event.target.elements.dropoff_address.value == "") {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Dropoff Address is required",
      });
      return false;
    } else if (event.target.elements.fullname.value < 3) {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Customer name is invalid",
      });
      return false;
    } 
     else if (phone === "") {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Phone Number is not empty",
      });
      return false;
    } else if (jobType === "") {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Select the job type",
      });
      return false;
    } else if (selectedOptionService.length === 0) {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Select the service",
      });
      return false;
    }else if(currentUser.role === 'owner' && event.target.elements?.invoiceNumber?.value === 'INV_'){
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Invoice number is required",
      });
    }
    
    else {
      setLoading(true)
      const invoiceItem = getInvoiceItems();
    
      let headersList = {
        Accept: "*/*",
        "Content-Type": "application/json",
      };
      const totalServiceCost = services.reduce(
        (sum, item) => sum + item.subtotal,
        0
      );

      const totalExtraCost = extraCosts.reduce((sum, item) => sum + item.amount, 0);
      const taxAmount = (totalServiceCost * tax) / 100;
      const discountAmount = (totalServiceCost * discount) / 100;
      const grandTotal =  totalServiceCost + totalExtraCost + taxAmount - discountAmount;
      let bodyContent = JSON.stringify({
        fullname: event.target.elements.fullname.value,
        email: currentUser.role == 'admin' ? null: event.target.elements.email?.value,
        phone: event.target.elements.phone.value,
        address: selectedPlace?.address,
        address_marker: selectedPlace?.lat + ',' + selectedPlace?.lng,
        dropoff_address: selectedPlaceDropoff?.address,
        dropoff_address_marker: selectedPlaceDropoff?.lat + ',' + selectedPlaceDropoff?.lng,
        tracking_status:statusForLiveTracking === true ? 1 : 0,
        zipcode: event.target.elements.zipcode.value,
        job_cost: event.target.elements.job_cost.value,
        assigned_to:
          currentUser.role === "owner"
            ? currentUser.id
            : selectedOptions?.value,
        assigned_by: currentUser?.id,
        driver_id: selectDriverSelect?.value,
        job_type: jobType,
        priority: priority,
        invoiceNumber : currentUser.role === "owner"
        ? event.target.elements?.invoiceNumber?.value : null,
        invoiceOurdueDate : currentUser.role === "owner"
        ? formatDateToDDMMYYYY(event.target.elements?.invoiceOurdueDate?.value) : null,
        invoiceItems: currentUser.role === "owner"
        ? invoiceItem : [],
        tax: currentUser.role === "owner"
        ?tax : null,
        discount: currentUser.role === "owner"
        ?discount: null,
        amount : currentUser.role === "owner"
        ?grandTotal: null,
        status_for_job: callType,
        license_plate: event.target.elements.license_plate.value,
        vehicle_type: event.target.elements.vehicle_Type.value,
        vehicle_year: event.target.elements.vehicle_Year.value,
        vehicle_make: event.target.elements.vehicle_Make.value,
        vehicle_model: event.target.elements.vehicle_Model.value,
        vehicle_color: event.target.elements.vehicle_Color.value,
        vin: event.target.elements.vin.value,
        service_request: formattedData?.toString(),
        recieved_time:completedDates.receivedDate,
        dipatched_time:completedDates.dispatchedDate,
        enroute_time:completedDates.enRouteDate,
        onscene_time:completedDates.onSceneDate,
        towing_time:completedDates.towingDate,
        destination_time:completedDates.destinationDate,
        completed_time: completedDates.completedDate,
        scheduled_date:scheduleDate,
        description: event.target.elements.description.value,
        job_posted_to: singleCheckedArray?.toString(),
      });
      let response;
      if (currentUser.role == "owner") {
        response = await fetch(API_URL + "/api/job/affiliate", {
          method: "POST",
          body: bodyContent,
          headers: headersList,
        });
      } else {
        response = await fetch(API_URL + "/api/jobs", {
          method: "POST",
          body: bodyContent,
          headers: headersList,
        });
      }
      let data = await response.json();
      setLoading(false)
      if (response.status == 201) {
        setshowAlertMessage({
          message: "success",
          status: true,
          desc: "Job Is assigned successfully",
        });
        setPhone("");
        event.target.elements.fullname.value = "";
        // event.target.elements.email.value = "";
        // event.target.elements.phone.value='';
        event.target.elements.address.value = "";
        event.target.elements.zipcode.value = "";
        event.target.elements.job_cost.value = "";
        event.target.elements.license_plate.value = "";
        event.target.elements.vehicle_Type.value = "";
        event.target.elements.vehicle_Year.value = "";
        event.target.elements.vehicle_Make.value = "";
        event.target.elements.vehicle_Model.value = "";
        event.target.elements.vehicle_Color.value = "";
        event.target.elements.vin.value = "";
        setAffilatesData([]);
        setFilterAffilatesData([]);
        setSelectedOptions({});
        setSelectedOptionService([]);
        setJobType("");
        setSelectedPlace(null)
        setSelectedPlaceDropoff(null)
        event.target.elements.description.value = "";
      } else {
        setshowAlertMessage({
          message: "error",
          status: true,
          desc: "Error while adding new job",
        });
      }
    }
  };
  
  const getCurrentUser = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user == null) {
      window.location.href = "/sign-in";
    } else {
      setCurrentUser(user);
    }
  };
  useEffect(() => {
    getCurrentUser();
  }, [1]);

 
  const handleCheckboxChange = (e, index) => {
    const checked = e.target.checked;
    const affiliate = affiliatesData[index];
    if (checked) {
      setSingleCheckedArray([...singleCheckedArray, affiliate]);
    } else {
      setSingleCheckedArray(
        singleCheckedArray.filter((item) => item !== affiliate)
      );
    }
  };

  const handleAssignClick = (index) => {
    const affiliate = filterAffilatesData[index];
    if (!singleCheckedArray.includes(affiliate.id)) {
      const updatedAffiliatesData = [...affiliatesData];
      updatedAffiliatesData[index].status = "marked";
      setFilterAffilatesData(updatedAffiliatesData);
      setSingleCheckedArray([...singleCheckedArray, affiliate.id]); // Store only the ID
    }
  };

  const handleRemoveClick = (index) => {
    const affiliate = filterAffilatesData[index];
    const updatedSingleCheckedArray = singleCheckedArray.filter(
      (id) => id !== affiliate.id
    );
    const updatedAffiliatesData = [...affiliatesData];
    updatedAffiliatesData[index].status = "active";
    setFilterAffilatesData(updatedAffiliatesData);
    setSingleCheckedArray(updatedSingleCheckedArray);
  };
 
  const toggleExpand = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
 
  useEffect(() => {
    const filteredData = () => {
      if (listType == "active_only") {
        const filter = affiliatesData.filter(
          (e) => e.status === "active" || e.status == "marked"
        );
        setFilterAffilatesData(filter);
      } else {
        setFilterAffilatesData(affiliatesData);
        // const filter = affiliatesData.filter((e)=>e.status === 'active');
      }
    };
    filteredData();
  }, [listType]);
  useEffect(() => {
    setCompletedDates({
      receivedDate: "",
      dispatchedDate: "",
      enRouteDate: "",
      onSceneDate: "",
      towingDate: "",
      destinationDate: "",
      completedDate: "",
    })
  }, [callType]);



  const handleChangeService = (selected) => {
    // Update the selected options
    setSelectedOptionService(selected);
  
    // Create a new services array by merging existing services with new selections
    const updatedServices = selected.map((newService) => {
      // Check if this service already exists in the current services array
      const existingService = services.find(
        (s) => s.value === newService.value
      );
  
      // If it exists, retain its qty, price, and subtotal; otherwise, initialize with defaults
      return existingService
        ? { ...newService, qty: existingService.qty, price: existingService.price, subtotal: existingService.subtotal }
        : { ...newService, qty: 1, price: 0, subtotal: 0 };
    });
  
    // Update the services state with the merged data
    setServices(updatedServices);
  };

  const handleQtyPriceChange = (index, field, value) => {
    const updatedServices = [...services];
    updatedServices[index][field] = Number(value);
    updatedServices[index].subtotal =
      updatedServices[index].qty * updatedServices[index].price;
    setServices(updatedServices);
  };

  const handleAddExtraCost = () => {
    setExtraCosts([...extraCosts, { name: "", amount: 0 }]);
  };

  const handleExtraCostChange = (index, field, value) => {
    const updatedCosts = [...extraCosts];
    updatedCosts[index][field] = field === "amount" ? Number(value) : value;
    setExtraCosts(updatedCosts);
  };

  const totalServiceCost = services.reduce(
    (sum, item) => sum + item.subtotal,
    0
  );
  const totalExtraCost = extraCosts.reduce((sum, item) => sum + item.amount, 0);
  const taxAmount = (totalServiceCost * tax) / 100;
  const discountAmount = (totalServiceCost * discount) / 100;
  const grandTotal =
    totalServiceCost + totalExtraCost + taxAmount - discountAmount;
  const getInvoiceItems = () => {
    const serviceItems = services.map((service) => ({
      item_name: service.label,
      quantity: service.qty,
      unit_price: service.price,
      price: service.subtotal,
    }));

    const extraCostItems = extraCosts.map((cost) => ({
      item_name: cost.name,
      quantity: 1,
      unit_price: cost.amount,
      price: cost.amount,
    }));

    return [...serviceItems, ...extraCostItems];
  };
  const handleRemoveExtraCost = (index) => {
    setExtraCosts(extraCosts.filter((_, i) => i !== index));
  };
  const handleChangeInvoice = (e) => {
    const value = e.target.value;
    // Ensure the value always starts with "INV_"
    if (!value.startsWith("INV_")) {
      setInvoiceNumber("INV_");
    } else {
      setInvoiceNumber(value); // Update with the full value including "INV_"
    }
  };
  
  

  // const onLoad = (autocomplete) => {
  //   console.log("Autocomplete loaded:", autocomplete); // Debug to ensure it loads
  //   autocompleteRef.current = autocomplete;
  // };

  // const onLoadIncident = (autocomplete) => {
  //   incidentAutocompleteRef.current = autocomplete;
  // };

  // const onLoadDropoff = (autocomplete) => {
  //   dropoffAutocompleteRef.current = autocomplete;
  // };

  // const onPlaceChanged = () => {
  //   if (incidentAutocompleteRef.current) {
  //     const place = incidentAutocompleteRef.current.getPlace();
  //     if (place && place.geometry) {
  //       getLatLongFromAddress(place.name)
  //       setSelectedPlace({
  //         name: place.name,
  //         address: place.formatted_address,
  //         lat: place.geometry.location.lat(),
  //         lng: place.geometry.location.lng(),
  //       });
  //       console.log("Incident Location:", place);
  //     }
  //   }
  // };

  // const onPlaceChangedDropoff = () => {
  //   if (dropoffAutocompleteRef.current) {
  //     const place = dropoffAutocompleteRef.current.getPlace();
  //     if (place && place.geometry) {
  //       const dropoff = {
  //         name: place.name,
  //         address: place.formatted_address,
  //         lat: place.geometry.location.lat(),
  //         lng: place.geometry.location.lng(),
  //       };
  //       setSelectedPlaceDropoff(dropoff);
  //       console.log("Dropoff Location:", dropoff);

  //       // Calculate ETA when dropoff is selected
  //       if (selectedPlace) {
  //         calculateETA(selectedPlace, dropoff);
  //       }
  //     }else{
  //       console.log('jherasdas')
  //     }
  //   }
  // };
  
  const calculateETA = async (origin, destination) => {
    try {
      if (!origin || !destination) {
        throw new Error("Both origin and destination are required");
      }

      const response = await fetch(
        `https://api.mapbox.com/directions/v5/mapbox/driving/${origin.lng},${origin.lat};${destination.lng},${destination.lat}?access_token=${mapboxgl.accessToken}`
      );
      
      if (!response.ok) {
        throw new Error(`Directions API error: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.routes && data.routes.length > 0) {
        const duration = data.routes[0].duration;
        const minutes = Math.round(duration / 60);
        setEta({
          seconds: duration,
          text: `${minutes} min`,
          distance: data.routes[0].distance // Adding distance in meters
        });
      } else {
        setEta(null);
        setshowAlertMessage({
          message: "error",
          status: true,
          desc: "No route found between locations",
        });
      }
    } catch (error) {
      console.error("Error calculating ETA:", error);
      setEta(null);
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Error calculating route. Please check locations.",
      });
    }
  };

 
  
    return (
      <>
        {/* MasterLayout */}
       
        <MasterLayout>
          {/* Breadcrumb */}
          <Breadcrumb title="Add Job" />

          {/* AddUserLayer */}
          <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
              <div className="row justify-content-center ">
                <div className="col-xxl-8 col-xl-8 col-lg-10">
                  <div className="card border">
                    <div className="card-body">
                      {/* Upload Image Start */}
                        
                      {/* Upload Image End */}
                      <form onSubmit={(event) => onFormSubmit(event)}>
                        <div className="mb-20">
                          <div className="mb-20">
                            <label
                              htmlFor="assigned_to"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              This is a...
                              <span className="text-danger-600">*</span>{" "}
                            </label>
                            <div className="d-flex align-items-center flex-wrap gap-28">
                              <div className="form-check checked-secondary d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="call_type"
                                  id="horizontal2211"
                                  onChange={(e) => setCallType(e.target.value)}
                                  value={"New Call"}
                                />
                                <label
                                  className="form-check-label line-height-1 fw-medium text-secondary-light"
                                  htmlFor="horizontal2211"
                                >
                                  New Call{" "}
                                </label>
                              </div>
                              <div className="form-check checked-secondary d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="call_type"
                                  id="horizontal221"
                                  onChange={(e) => setCallType(e.target.value)}
                                  value={"Completed"}
                                />
                                <label
                                  className="form-check-label line-height-1 fw-medium text-secondary-light"
                                  htmlFor="horizontal221"
                                >
                                  Completed Call{" "}
                                </label>
                              </div>
                              <div className="form-check checked-secondary d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="call_type"
                                  id="horizontal2333"
                                  onChange={(e) => setCallType(e.target.value)}
                                  value={"Schedule"}
                                />
                                <label
                                  className="form-check-label line-height-1 fw-medium text-secondary-light"
                                  htmlFor="horizontal2333"
                                >
                                  Schedule a call{" "}
                                </label>
                              </div>
                              <div className="form-check checked-secondary d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="call_type"
                                  id="horizontal233"
                                  onChange={(e) => setCallType(e.target.value)}
                                  value={"Quote"}
                                />
                                <label
                                  className="form-check-label line-height-1 fw-medium text-secondary-light"
                                  htmlFor="horizontal233"
                                >
                                  Quote{" "}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {callType == "Completed" ? (
                          <div className="row">
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="receivedDate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Received Date & Time
                              </label>
                              <input
                                value={completedDates.receivedDate}
                                onChange={(e) =>
                                  setCompletedDates((prev) => ({
                                    ...prev,
                                    receivedDate: e.target.value,
                                  }))
                                }
                                type="datetime-local"
                                className="form-control radius-8"
                                id="receivedDate"
                                name="receivedDate"
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="dispatchedDate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Dispatched Date & Time
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control radius-8"
                                id="dispatchedDate"
                                name="dispatchedDate"
                                value={completedDates.dispatchedDate}
                                onChange={(e) =>
                                  setCompletedDates((prev) => ({
                                    ...prev,
                                    dispatchedDate: e.target.value,
                                  }))
                                }
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="onSceneDate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                En route Date & Time
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control radius-8"
                                id="onSceneDate"
                                name="onSceneDate"
                                value={completedDates.enRouteDate}
                                onChange={(e) =>
                                  setCompletedDates((prev) => ({
                                    ...prev,
                                    enRouteDate: e.target.value,
                                  }))
                                }
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="onSceneDate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                On Scene Date & Time
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control radius-8"
                                id="onSceneDate"
                                value={completedDates.onSceneDate}
                                onChange={(e) =>
                                  setCompletedDates((prev) => ({
                                    ...prev,
                                    onSceneDate: e.target.value,
                                  }))
                                }
                                name="onSceneDate"
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="towingDate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Towing Date & Time
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control radius-8"
                                id="towingDate"
                                name="towingDate"
                                value={completedDates.towingDate}
                                onChange={(e) =>
                                  setCompletedDates((prev) => ({
                                    ...prev,
                                    towingDate: e.target.value,
                                  }))
                                }
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="destinationDate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Destination Arrival Date & Time
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control radius-8"
                                id="destinationDate"
                                name="destinationDate"
                                value={completedDates.destinationDate}
                                onChange={(e) =>
                                  setCompletedDates((prev) => ({
                                    ...prev,
                                    destinationDate: e.target.value,
                                  }))
                                }
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="completedDate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Completed Date & Time
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control radius-8"
                                id="completedDate"
                                value={completedDates.completedDate}
                                onChange={(e) =>
                                  setCompletedDates((prev) => ({
                                    ...prev,
                                    completedDate: e.target.value,
                                  }))
                                }
                                name="completedDate"
                              />
                            </div>
                          </div>
                        ) : callType == "Schedule" ? (
                          <div className="row">
                            <div className="col-md-6 mt-3">
                              <label
                                htmlFor="schedule_date"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Schedule Date & Time
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control radius-8"
                                id="schedule_date"
                                value={scheduleDate}
                                onChange={(e) =>
                                  setScheduleDate(e.target.value)
                                }
                                name="schedule_date"
                              />
                            </div>
                          </div>
                        ) : null}
                            <div className="mb-20">
                          <label
                            htmlFor="assigned_to"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Select Driver
                          </label>
                          
                          <Select
                            options={selectDriver}
                            value={selectDriverSelect}
                            styles={{
                              // Style the dropdown menu container
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9000, // Apply zIndex to the dropdown menu
                              }),
                              // Optional: Style the menuList if you need additional tweaks
                             
                            }}
                            placeholder="Select Options"
                          />
                        </div>
                        <div className="mb-20">

                        </div>
                        <div className="mb-20">
      <div className="row">
        <div className="col-md-6">
          <label
            htmlFor="address"
            className="form-label fw-semibold text-primary-light text-sm mb-8"
          >
            Incident Location
            <span className="text-danger-600">*</span>
          </label>
          <div 
          id="incident-location-container"
          key={`incident-${isMounted}`} // Force re-creation
          style={{ minHeight: '50px' }}
        />
        <input
          type="hidden"
          name="address"
          value={selectedPlace?.address || ''}
          required
        />
        </div>
        
        <div className="col-md-6">
        <label
            htmlFor="dropoff_address"
            className="form-label fw-semibold text-primary-light text-sm mb-8"
          >
            Dropoff Location
            <span className="text-danger-600">*</span>
          </label>
        <div 
          id="dropoff-location-container"
          key={`dropoff-${isMounted}`} // Force re-creation
          style={{ minHeight: '50px' }}
        />
        <input
          type="hidden"
          name="dropoff_address"
          value={selectedPlaceDropoff?.address || ''}
          required
        />
          <input
            type="hidden"
            className="form-control radius-8"
            id="zip_code"
            name="zipcode"
            placeholder="ZipCode"
          />
        </div>
        <div className="col-md-12 mt-3">
         
        </div>
      </div>
      {eta && (
        <div className="mt-3 alert alert-info">
          <p className="mb-0">
            Estimated Travel Time: <strong>{eta.text}</strong> ({Math.round(eta.seconds / 60)} minutes)
            {eta.distance && (
              <span>, Distance: {Math.round(eta.distance / 1000)} km</span>
            )}
          </p>
        </div>
      )}
      <div className="mb-2">
      <div className="form-switch switch-success d-flex align-items-center gap-3 mb-40 mt-40">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switch1"
                                name="notification_send"
                                onChange={(e)=>{if(e.target.checked==true){showPopUp()}else{setStatusForLiveTracking(false)}}}
                                checked={statusForLiveTracking === true ? true :false}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch1"
                            >
                                Do you want to enable the live tracking for this job?
                            </label>
                        </div>
      </div>
    </div>
                      
                        <div>
                          <h6>Customer Information</h6>
                        </div>
                        <div className="mb-20">
                          <label
                            htmlFor="name"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Full Name <span className="text-danger-600">*</span>
                          </label>
                          <input
                            type="text"
                            name="fullname"
                            className="form-control radius-8"
                            id="name"
                            placeholder="Enter Full Name"
                          />
                        </div>
                        <div className="mb-20">
                          <div className="row">
                            <div className="col-md-6">
                              <label
                                htmlFor="email"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Email
                              </label>
                              <input
                                type="email"
                                name="email"
                                className="form-control radius-8"
                                id="email"
                                placeholder="Enter Email Address"
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="phone"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Phone <span className="text-danger-600">*</span>
                              </label>
                              <input
                                type="tel"
                                name="phone"
                                value={phone}
                                onChange={handleInputChange}
                                className="form-control radius-8"
                                id="phone"
                                placeholder="Enter Phone Number"
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          <h6>Vehicle Information</h6>
                        </div>
                        <div className="mb-20">
                          <div className="row">
                            <div className="col-md-6">
                              <label
                                htmlFor="license_plate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                License Plate
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="license_plate"
                                name="license_plate"
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="vin"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                VIN
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="vin"
                                name="vin"
                              />
                            </div>
                            <div style={{ paddingTop: 10 }} />
                            <div className="col-md-4">
                              <label
                                htmlFor="vehicle_Type"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Type
                              </label>
                              <Typeahead
                                      labelKey="type"
                                      id="vehicle_Type"
                                      options={vehicleOptions} // Plain string array
                                      onChange={(selected) => {
                                        setSelected(selected); // Update selected array
                                      }}
                                      // onInputChange={(text) => {
                                      //   // Allow free typing by updating selected if text doesn't match an option
                                      //   if (!vehicleOptions.includes(text)) {
                                      //     setSelected([text]);
                                      //   }
                                      // }}
                                      selected={selected} // Controlled value as an array
                                      placeholder=""
                                      inputProps={{
                                        className: "form-control radius-8",
                                        name: "vehicle_Type",
                                      }}
                                      className="radius-8"
                                    />
                            </div>
                            <div className="col-md-4">
                              <label
                                htmlFor="vehicle_Year"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Year
                              </label>
                              
                                <Typeahead
                                      labelKey="name"
                                      id="vehicle_Year"
                                      // align="left"
                                      // filterBy={"name"}
                                      options={VehicleYear} // Plain string array
                                      onChange={(selected) => {
                                        setSelectedYear(selected); // Update selected array
                                      }}
                                      selected={selectedYear} // Controlled value as an array
                                      placeholder=""
                                      inputProps={{
                                        className: "form-control radius-8",
                                        name: "vehicle_Year",
                                      }}
                                      className="radius-8"
                                    />
                            </div>
                            <div className="col-md-4">
                              <label
                                htmlFor="vehicle_Make"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Make
                              </label>
                              <Typeahead
                                      labelKey="name"
                                      id="vehicle_Make"
                                      // align="left"
                                      // filterBy={"name"}
                                      options={vehicleMake} // Plain string array
                                      onChange={(selected) => {
                                        setSelectedMake(selected); // Update selected array
                                        console.log(selected)
                                        setVehicleModelArray(getVehicleModelsByMake(selected[0]));
                                      }}
                                      selected={selectedMake} // Controlled value as an array
                                      placeholder=""
                                      inputProps={{
                                        className: "form-control radius-8",
                                        name: "vehicle_Make",
                                      }}
                                      className="radius-8"
                                    />
                             
                            </div>
                            <div style={{ paddingTop: 10 }} />
                            <div className="col-md-4">
                              <label
                                htmlFor="vehicle_Model"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Model
                              </label>
                              <Typeahead
                                      labelKey="name"
                                      id="vehicle_Model"
                                      // align="left"
                                      // filterBy={"name"}
                                      options={vehicleModelArray} // Plain string array
                                      onChange={(selected) => {
                                        setSelectedModel(selected); // Update selected array
                                      }}
                                      selected={selectedModel} // Controlled value as an array
                                      placeholder=""
                                      inputProps={{
                                        className: "form-control radius-8",
                                        name: "vehicle_Model",
                                      }}
                                      className="radius-8"
                                    />
                            
                            </div>
                            <div className="col-md-4">
                              <label
                                htmlFor="vehicle_Color"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Color
                              </label>
                              <Typeahead
                                      labelKey="type"
                                      id="vehicle_Color"
                                      options={carColors} // Plain string array
                                      onChange={(selected) => {
                                        setSelectedModelCarColor(selected); // Update selected array
                                      }}
                                      // onInputChange={(text) => {
                                      //   // Allow free typing by updating selected if text doesn't match an option
                                      //   if (!vehicleOptions.includes(text)) {
                                      //     setSelected([text]);
                                      //   }
                                      // }}
                                      selected={selectedCarColor} // Controlled value as an array
                                      placeholder=""
                                      inputProps={{
                                        className: "form-control radius-8",
                                        name: "vehicle_Color",
                                      }}
                                      className="radius-8"
                                    />
                             
                            </div>
                          </div>
                        </div>
                        <div className="mb-20">
                          <div className="row">
                            <div className="col-md-6">
                              <label
                                htmlFor="job_cost"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Job Cost
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="job_cost"
                                name="job_cost"
                                placeholder="0.00"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mb-20">
                          <label
                            htmlFor="assigned_to"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Priority
                            <span className="text-danger-600">*</span>{" "}
                          </label>
                          <div className="d-flex align-items-center flex-wrap gap-28">
                            <div className="form-check checked-primary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="priority"
                                id="horizontal11"
                                onChange={(e) => setPriority(e.target.value)}
                                value={"normal"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal11"
                              >
                                Normal{" "}
                              </label>
                            </div>
                            <div className="form-check checked-secondary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="priority"
                                id="horizontal22"
                                onChange={(e) => setPriority(e.target.value)}
                                value={"emergency"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal22"
                              >
                                Emergency{" "}
                              </label>
                            </div>
                            <div className="form-check checked-secondary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="priority"
                                id="horizontal23"
                                onChange={(e) => setPriority(e.target.value)}
                                value={"low"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal23"
                              >
                                Low{" "}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="mb-20">
                          <label
                            htmlFor="assigned_to"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Job Type
                            <span className="text-danger-600">*</span>{" "}
                          </label>
                          <div className="d-flex align-items-center flex-wrap gap-28">
                            <div className="form-check checked-primary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="horizontal"
                                id="horizontal1"
                                onChange={(e) => setJobType(e.target.value)}
                                value={"Roadside Assistance"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal1"
                              >
                                Roadside Assistance{" "}
                              </label>
                            </div>
                            <div className="form-check checked-secondary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="horizontal"
                                id="horizontal2"
                                onChange={(e) => setJobType(e.target.value)}
                                value={"Towing Service"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal2"
                              >
                                Towing Service{" "}
                              </label>
                            </div>
                          </div>
                        </div>

                        

                        <div className="mb-20">
                          <label
                            htmlFor="desc"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Description
                          </label>
                          <textarea
                            className="form-control radius-8"
                            id="desc"
                            placeholder="Write description..."
                            name="description"
                          />
                        </div>
                        <div className="container mt-5 p-4  rounded  bg-white">
                          <div className="mb-3">
                            <label className="form-label fw-semibold">
                              Select Services{" "}
                            </label>
                              <Select
                                options={options}
                                isMulti
                                value={selectedOptionService}
                                onChange={handleChangeService}
                                placeholder="Select Services"
                              />
                            </div>

                            {services.length > 0 && (
                              <table className="table table-bordered mt-4">
                                <thead className="table-dark">
                                  <tr>
                                    <th>Service</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Subtotal</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {services.map((service, index) => (
                                    <tr key={service.value}>
                                      <td>{service.label}</td>
                                      <td>
                                        <input
                                          className="form-control"
                                          type="number"
                                          min="1"
                                          value={service.qty}
                                          onChange={(e) =>
                                            handleQtyPriceChange(
                                              index,
                                              "qty",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          className="form-control"
                                          type="number"
                                          min="0"
                                          value={service.price}
                                          onChange={(e) =>
                                            handleQtyPriceChange(
                                              index,
                                              "price",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>${service.subtotal.toFixed(2)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}

                          <button
                            type="button"
                            className="btn btn-primary mt-3"
                            onClick={handleAddExtraCost}
                          >
                            + Add Extra Cost
                          </button>

                          {extraCosts.length > 0 && (
                            <table className="table table-bordered mt-3">
                              <thead className="table-secondary">
                                <tr>
                                  <th>Extra Cost Name</th>
                                  <th>Amount</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {extraCosts.map((cost, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Cost Name"
                                        value={cost.name}
                                        onChange={(e) =>
                                          handleExtraCostChange(
                                            index,
                                            "name",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        type="number"
                                        min="0"
                                        placeholder="Amount"
                                        value={cost.amount}
                                        onChange={(e) =>
                                          handleExtraCostChange(
                                            index,
                                            "amount",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <Button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveExtraCost(index)
                                        }
                                        className="btn btn-danger"
                                      >
                                        X
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}

                          <div className="row mt-3 mb-3">
                          <div className="col-md-4">
                          <label htmlFor="invoiceNumber" className="form-label fw-semibold">
                            Invoice Number
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="invoiceNumber"
                            id="invoiceNumber"
                            value={invoiceNumber}
                            onChange={handleChangeInvoice}
                            placeholder="INV_12345"
                          />
                        </div>
                            <div className="col-md-4">
                            
                              <label htmlFor="invoiceOurdueDate" className="form-label fw-semibold">
                               Overdue Date
                              </label>
                              <input
                                className="form-control"
                                type="date"
                                name="invoiceOurdueDate"
                                min="0"
                               
                              />
                            </div>
                            <div className="col-md-2">
                            
                              <label className="form-label fw-semibold">
                                Tax (%)
                              </label>
                              <input
                                className="form-control"
                                type="number"
                                min="0"
                                value={tax}
                                onChange={(e) => setTax(Number(e.target.value))}
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="form-label fw-semibold">
                                Dis (%)
                              </label>
                              <input
                                className="form-control"
                                type="number"
                                min="0"
                                value={discount}
                                onChange={(e) =>
                                  setDiscount(Number(e.target.value))
                                }
                              />
                            </div>
                          </div>

                          <table className="table table-bordered mt-4">
                            <tbody>
                              <tr>
                                <td className="fw-semibold">Service Total</td>
                                <td>${totalServiceCost.toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td className="fw-semibold">Extra Costs</td>
                                <td>${totalExtraCost.toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td className="fw-semibold">Tax</td>
                                <td>${taxAmount.toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td className="fw-semibold">Discount</td>
                                <td>-${discountAmount.toFixed(2)}</td>
                              </tr>
                              <tr className="table-success">
                                <td className="fw-bold fs-5">Grand Total</td>
                                <td className="fw-bold fs-5">
                                  ${grandTotal.toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {showAlertMessage.status === true ? (
                          <div
                            className={
                              showAlertMessage.message == "error"
                                ? "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                                : "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                            }
                            role="alert"
                          >
                            {showAlertMessage.desc}
                            <button
                              type="button"
                              onClick={() =>
                                setshowAlertMessage(!showAlertMessage)
                              }
                              className="remove-button text-secondary-600 text-xxl line-height-1"
                            >
                              {" "}
                              <Icon
                                icon="iconamoon:sign-times-light"
                                className="icon"
                              />
                            </button>
                          </div>
                        ) : null}
                        
                        <div className="d-flex align-items-center justify-content-center gap-3">
                         {
                          loading === true ?
                          <Spinner/>:
                          <button
                            type="submit"
                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                          >
                            Save
                          </button>
                         }
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </MasterLayout>
        
      </>
    );
  
};

export default AddJobs;
